import { DEFAULT_FORMAT_FALLBACK } from './constants';
import { FormatValueOptions } from './types';

export const formatValue = (options: FormatValueOptions): string => {
  const {
    fallback = DEFAULT_FORMAT_FALLBACK,
    value
  } = options;

  if (value === null || value === undefined || value === '') return fallback;

  return String(value);
};